export const STAFF_TURNOVER_MODULE_TITLE = "Staff Turnover";
export const STAFF_TURNOVER_ROUTE_SLUG = "staff-turnover";
export const STAFF_TURNOVER_MODULE_PATH =
  `/human-resource/${STAFF_TURNOVER_ROUTE_SLUG}/${STAFF_TURNOVER_ROUTE_SLUG}`;

export const RESIGNATION_LIST_REQUEST = "RESIGNATION_LIST_REQUEST";
export const RESIGNATION_LIST_SUCCESS = "RESIGNATION_LIST_REQUEST_SUCCESS";
export const RESIGNATION_CREATE_REQUEST = "RESIGNATION_CREATE_REQUEST";
export const RESIGNATION_DETAIL_REQUEST = "RESIGNATION_DETAIL_REQUEST";
export const RESIGNATION_ARCHIVE_REQUEST = "RESIGNATION_ARCHIVE_REQUEST";
export const RESIGNATION_DELETE_REQUEST = "RESIGNATION_DELETE_REQUEST";
export const RESIGNATION_UNARCHIVE_REQUEST = "RESIGNATION_UNARCHIVE_REQUEST";
export const RESIGNATION_CREATE_FORM_NAME = "createResignation";

export const RESIGNATION_APPROVE_REQUEST = "RESIGNATION_APPROVE_REQUEST";
export const RESIGNATION_REJECT_REQUEST = "RESIGNATION_REJECT_REQUEST";
export const RESIGNATION_PROCESS_REQUEST = "RESIGNATION_PROCESS_REQUEST";
export const RESIGNATION_SUBMIT_REQUEST = "RESIGNATION_SUBMIT_REQUEST";

/** Draft — saved, not submitted (no notifications) */
export const RESIGNATION_STATUS_DRAFT = 1;
export const RESIGNATION_STATUS_DRAFT_TITLE = "Draft";

/** Submitted — awaiting line manager (legacy API values `0` / `null` map here) */
export const RESIGNATION_STATUS_SUBMITTED = 2;
export const RESIGNATION_STATUS_SUBMITTED_TITLE = "Submitted";

/** LM approved — awaiting HR */
export const RESIGNATION_STATUS_LM_APPROVED = 3;
export const RESIGNATION_STATUS_LM_APPROVED_TITLE = "LM Approved";

/** HR approved — ready to process */
export const RESIGNATION_STATUS_HR_APPROVED = 4;
export const RESIGNATION_STATUS_HR_APPROVED_TITLE = "HR Approved";

/** Processed */
export const RESIGNATION_STATUS_PROCESSED = 5;
export const RESIGNATION_STATUS_PROCESSED_TITLE = "Processed";

/** Rejected */
export const RESIGNATION_STATUS_REJECTED = 6;
export const RESIGNATION_STATUS_REJECTED_TITLE = "Rejected";

export const RESIGNATION_STATUS = [
  {
    id: RESIGNATION_STATUS_DRAFT,
    name: RESIGNATION_STATUS_DRAFT_TITLE,
  },
  {
    id: RESIGNATION_STATUS_SUBMITTED,
    name: RESIGNATION_STATUS_SUBMITTED_TITLE,
  },
  {
    id: RESIGNATION_STATUS_LM_APPROVED,
    name: RESIGNATION_STATUS_LM_APPROVED_TITLE,
  },
  {
    id: RESIGNATION_STATUS_HR_APPROVED,
    name: RESIGNATION_STATUS_HR_APPROVED_TITLE,
  },
  {
    id: RESIGNATION_STATUS_PROCESSED,
    name: RESIGNATION_STATUS_PROCESSED_TITLE,
  },
  {
    id: RESIGNATION_STATUS_REJECTED,
    name: RESIGNATION_STATUS_REJECTED_TITLE,
  },
];

export const RESIGNATION_SUBMIT_RULES = {
  employeeId: {
    required: true,
  },
  resignationDate: {
    required: true,
  },
  reason: {
    required: true,
  },
};

export const READ_RESIGNATION = 148000;
export const CREATE_RESIGNATION = 148001;
export const UPDATE_RESIGNATION = 148002;
export const DELETE_RESIGNATION = 148003;
export const ARCHIVE_RESIGNATION = 148004;
export const UNARCHIVE_RESIGNATION = 148005;
export const BATCH_DELETE_RESIGNATION = 148006;
export const IMPORT_RESIGNATION = 148008;
/** WriteResignation — create / resubmit */
export const WRITE_RESIGNATION = CREATE_RESIGNATION;
/** ApproveResignation — override LM / HR approver checks */
export const APPROVE_RESIGNATION = 148011;
export const REJECT_RESIGNATION = 148012;
export const PROCESS_RESIGNATION = 148013;
